/** Datadog and W3C trace context headers allowed on cross-origin requests. */
const CORS_TRACE_HEADERS = [
  "x-datadog-trace-id",
  "x-datadog-parent-id",
  "x-datadog-origin",
  "x-datadog-sampling-priority",
  "x-datadog-tags",
  "traceparent",
  "tracestate",
  "baggage",
];

const CORS_TRACE_HEADERS_VALUE = CORS_TRACE_HEADERS.join(", ");

/** Appends Datadog/W3C trace headers to an existing Access-Control-Allow-Headers value. */
const withCorsTraceHeaders = (allowHeaders) => `${allowHeaders}, ${CORS_TRACE_HEADERS_VALUE}`;

module.exports = {
  CORS_TRACE_HEADERS,
  CORS_TRACE_HEADERS_VALUE,
  withCorsTraceHeaders,
};
